/**
 * A price that INCLUDES VAT, split into its net amount and its VAT
 * (`payments.vatIncludedRate` — Chile, IVA 19 % incluido). Whole units: the
 * net is the gross over `1 + rate`, rounded to the unit, and the VAT is the
 * rest, so `net + vat === gross` always holds and the two lines a buyer reads
 * add up to the price he pays. CLP has no cents, so this is exact in pesos:
 * $ 39.990 = $ 33.605 neto + $ 6.385 IVA.
 *
 * Display only — nothing here changes what is charged: the Stripe Price is the
 * gross plan price (`plans.price_uzs`).
 */
export function vatIncludedBreakdown(gross: number, rate: number): { net: number; vat: number } {
  if (!Number.isFinite(gross) || !(rate > 0)) return { net: Math.round(gross), vat: 0 };
  const total = Math.round(gross);
  const net = Math.round(total / (1 + rate));
  return { net, vat: total - net };
}
